import { Box, Text } from '@wix/design-system';
import React, { FC, useMemo } from 'react';

import { BACKGROUND_DARK_COLOR } from '../../../../constants';
import s from './MessageBubble.scss';

interface MessageBubbleProps {
  fromUser?: boolean;
  isFirstInGroup?: boolean;
  icon?: React.ReactNode;
  padding?: 'standard' | 'none';
}

export const MessageBubble: FC<MessageBubbleProps> = ({
  fromUser = false,
  isFirstInGroup,
  icon,
  padding = 'standard',
  children,
}) => {
  const borderRadius = useMemo(() => {
    if (isFirstInGroup) {
      return fromUser ? '18px 3px 18px 18px' : '3px 18px 18px 18px';
    }

    return '18px';
  }, [isFirstInGroup, fromUser]);

  const backgroundColor = fromUser ? BACKGROUND_DARK_COLOR : 'D70';
  const boxPadding = useMemo(() => {
    if (padding === 'none') {
      return undefined;
    }

    return icon ? 'SP2 SP3 SP2 SP2' : 'SP2 SP3';
  }, [padding, icon]);

  return (
    <Box
      className={s.messageBubble}
      backgroundColor={backgroundColor}
      padding={boxPadding}
      borderRadius={borderRadius}
      gap="SP1"
      width="fit-content"
      maxWidth="100%"
    >
      {icon && (
        <Box height="fit-content" display="flex" verticalAlign="middle">
          {icon}
        </Box>
      )}
      <Box direction="vertical" overflow="hidden">
        <Text className={s.text} light={fromUser} weight={fromUser ? 'normal' : 'thin'} listStyle="circle">
          {children}
        </Text>
      </Box>
    </Box>
  );
};
